var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('arctic-template',{attrs:{"version":"1.0.3","primary-nav":_vm.primaryNav,"secondary-nav":_vm.secondaryNav}})}
var staticRenderFns = []

export { render, staticRenderFns }